import { api } from "./api";
import { getPendingScans, markScan } from "./idb";

let syncing = false;

export async function syncOfflineScans() {
  if (syncing) return { ok: false, reason: "already_syncing" };
  if (!navigator.onLine) return { ok: false, reason: "offline" };
  syncing = true;
  try {
    const pending = await getPendingScans();
    if (pending.length === 0) return { ok: true, synced: 0, failed: 0 };
    const entries = pending.map((p) => ({
      token: p.token,
      event_id: p.event_id,
      timestamp: p.timestamp,
      client_id: p.client_id,
    }));
    const { data } = await api.post("/attendance/bulk-sync", { entries });
    let synced = 0,
      failed = 0,
      duplicate = 0;
    for (const r of data.results || []) {
      if (r.status === "recorded") {
        synced++;
        await markScan(r.client_id, "synced", "recorded");
      } else if (r.status === "duplicate") {
        duplicate++;
        await markScan(r.client_id, "synced", "duplicate");
      } else {
        failed++;
        await markScan(r.client_id, "failed", r.status);
      }
    }
    return { ok: true, synced, failed, duplicate };
  } catch (e) {
    return { ok: false, reason: e.message };
  } finally {
    syncing = false;
  }
}

export function attachAutoSync() {
  window.addEventListener("online", () => {
    syncOfflineScans();
  });
  setInterval(() => {
    if (navigator.onLine) syncOfflineScans();
  }, 30000);
}
